import script from "./AddGuardian.vue?vue&type=script&setup=true&lang=js"
export * from "./AddGuardian.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__